export const botZipCode = '33613'

type RetailerData = {
  zip: string
  category: string
  storeIds: string[]
}

export const retailerDataForBots: Record<string, RetailerData> = {
  publix: {
    zip: '32940',
    category: 'Grocery Delivery',
    storeIds: ['1'],
  },
  kroger: {
    zip: '43201',
    category: 'Grocery Delivery',
    storeIds: ['2'],
  },
  'frys-food': {
    zip: '85746',
    category: 'Grocery Delivery',
    storeIds: ['4'],
  },
  'giant-eagle': {
    zip: '43212',
    category: 'Grocery Delivery',
    storeIds: ['5'],
  },
  'harris-teeter': {
    zip: '23606',
    category: 'Grocery Delivery',
    storeIds: ['6'],
  },
  'h-e-b': {
    zip: '77840',
    category: 'Grocery Delivery',
    storeIds: ['8'],
  },
  meijer: {
    zip: '49512',
    category: 'Delivery',
    storeIds: ['10'],
  },
  'central-market': {
    zip: '78756',
    category: 'Grocery Delivery',
    storeIds: ['11'],
  },
  'abc-fine-wine-spirits': {
    zip: '33928',
    category: 'Alcohol Delivery',
    storeIds: ['12'],
  },
  smiths: {
    zip: '89147',
    category: 'Grocery Delivery',
    storeIds: ['14'],
  },
  safeway: {
    zip: '95661',
    category: 'Grocery Delivery',
    storeIds: ['498'],
  },
  'lowes-foods': {
    zip: '28075',
    category: 'Grocery Delivery',
    storeIds: ['20'],
  },
  dierbergs: {
    zip: '63119',
    category: 'Grocery Delivery',
    storeIds: ['23'],
  },
  'reasors-foods': {
    zip: '74037',
    category: 'Grocery Delivery',
    storeIds: ['24'],
  },
  'winn-dixie': {
    zip: '32828',
    category: 'Grocery Delivery',
    storeIds: ['26'],
  },
  target: {
    zip: '92562',
    category: 'Delivery',
    storeIds: ['27'],
  },
  'rouses-markets': {
    zip: '70791',
    category: 'Grocery Delivery',
    storeIds: ['28'],
  },
  'fred-meyer': {
    zip: '98038',
    category: 'Grocery Delivery',
    storeIds: ['30', '807'],
  },
  'king-soopers': {
    zip: '80005',
    category: 'Grocery Delivery',
    storeIds: ['32'],
  },
  'gordon-food-service-store': {
    zip: '15205',
    category: 'Grocery Delivery',
    storeIds: ['33'],
  },
  qfc: {
    zip: '98029',
    category: 'Grocery Delivery',
    storeIds: ['40'],
  },
  dillons: {
    zip: '67037',
    category: 'Grocery Delivery',
    storeIds: ['42'],
  },
  'weis-markets': {
    zip: '18062',
    category: 'Grocery Delivery',
    storeIds: ['43'],
  },
  'roche-bros': {
    zip: '02132',
    category: 'Grocery Delivery',
    storeIds: ['47'],
  },
  'sudbury-farms': {
    zip: '01776',
    category: 'Grocery Delivery',
    storeIds: ['48'],
  },
  'brothers-marketplace': {
    zip: '02332',
    category: 'Grocery Delivery',
    storeIds: ['49'],
  },
  'market-district': {
    zip: '15205',
    category: 'Grocery Delivery',
    storeIds: ['51'],
  },
  'hy-vee': {
    zip: '54304',
    category: 'Grocery Delivery',
    storeIds: ['52'],
  },
  'morton-williams': {
    zip: '10023',
    category: 'Grocery Delivery',
    storeIds: ['57'],
  },
  'fairway-markets': {
    zip: '10023',
    category: 'Grocery Delivery',
    storeIds: ['58'],
  },
  kowalskis: {
    zip: '55082',
    category: 'Grocery Delivery',
    storeIds: ['59'],
  },
  cvs: {
    zip: '08003',
    category: 'Pharmacy Delivery',
    storeIds: ['60'],
  },
  'foods-co': {
    zip: '93304',
    category: 'Grocery Delivery',
    storeIds: ['61'],
  },
  ralphs: {
    zip: '92037',
    category: 'Grocery Delivery',
    storeIds: ['62'],
  },
  'fresco-y-mas': {
    zip: '33142',
    category: 'Grocery Delivery',
    storeIds: ['71'],
  },
  'crest-foods': {
    zip: '73034',
    category: 'Grocery Delivery',
    storeIds: ['74'],
  },
  'joe-vs': {
    zip: '77088',
    category: 'Grocery Delivery',
    storeIds: ['75'],
  },
  shaws: {
    zip: '01605',
    category: 'Grocery Delivery',
    storeIds: ['815'],
  },
  redners: {
    zip: '17078',
    category: 'Grocery Delivery',
    storeIds: ['84'],
  },
  'winn-dixie-liquor': {
    zip: '32550',
    category: 'Alcohol Delivery',
    storeIds: ['85'],
  },
  'smart-final': {
    zip: '93063',
    category: 'Grocery Delivery',
    storeIds: ['88'],
  },
  petco: {
    zip: '03103',
    category: 'Pet Supplies Delivery',
    storeIds: ['89'],
  },
  'bridge-street-market': {
    zip: '49504',
    category: 'Grocery Delivery',
    storeIds: ['90'],
  },
  'star-market': {
    zip: '02026',
    category: 'Grocery Delivery',
    storeIds: ['816'],
  },
  'liquor-boy': {
    zip: '55416',
    category: 'Alcohol Delivery',
    storeIds: ['95'],
  },
  'harveys-supermarket': {
    zip: '32216',
    category: 'Grocery Delivery',
    storeIds: ['103'],
  },
  'piggly-wiggly': {
    zip: '36532',
    category: 'Grocery Delivery',
    storeIds: ['105', '16'],
  },
  'office-depot-officemax': {
    zip: '96814',
    category: 'Office Supplies Delivery',
    storeIds: ['122'],
  },
  'woodward-corner-market': {
    zip: '48073',
    category: 'Grocery Delivery',
    storeIds: ['124'],
  },
  'food-city': {
    zip: '85037',
    category: 'Grocery Delivery',
    storeIds: ['131', '707'],
  },
  ajs: {
    zip: '85253',
    category: 'Grocery Delivery',
    storeIds: ['132'],
  },
  bashas: {
    zip: '85715',
    category: 'Grocery Delivery',
    storeIds: ['133'],
  },
  sedanos: {
    zip: '33013',
    category: 'Grocery Delivery',
    storeIds: ['134'],
  },
  'top-ten-liquors': {
    zip: '55434',
    category: 'Alcohol Delivery',
    storeIds: ['146'],
  },
  'capital-city-market': {
    zip: '48912',
    category: 'Grocery Delivery',
    storeIds: ['151'],
  },
  'lunds-byerlys': {
    zip: '55416',
    category: 'Grocery Delivery',
    storeIds: ['157'],
  },
  marianos: {
    zip: '60108',
    category: 'Grocery & Pharmacy Delivery',
    storeIds: ['164'],
  },
  'dw-fresh-market': {
    zip: '49770',
    category: 'Grocery Delivery',
    storeIds: ['171'],
  },
  'family-fare': {
    zip: '49423',
    category: 'Grocery Delivery',
    storeIds: ['172'],
  },
  'vgs-grocery': {
    zip: '48430',
    category: 'Grocery Delivery',
    storeIds: ['173'],
  },
  'kuhns-market': {
    zip: '15216',
    category: 'Grocery Delivery',
    storeIds: ['175'],
  },
  'cardenas-markets': {
    zip: '89107',
    category: 'Grocery Delivery',
    storeIds: ['187'],
  },
  walgreens: {
    zip: '35222',
    category: 'Pharmacy Delivery',
    storeIds: ['188'],
  },
  'wds-wine-liquor-and-beer': {
    zip: '32207',
    category: 'Alcohol Delivery',
    storeIds: ['190'],
  },
  '7-eleven': {
    zip: '94103',
    category: 'Convenience Delivery',
    storeIds: ['192'],
  },
  'fresco-y-mas-liquor': {
    zip: '33126',
    category: 'Alcohol Delivery',
    storeIds: ['197'],
  },
  'rivertown-market': {
    zip: '48207',
    category: 'Grocery Delivery',
    storeIds: ['198'],
  },
  'food-bazaar': {
    zip: '11101',
    category: 'Grocery Delivery',
    storeIds: ['201'],
  },
  'golden-age-wine': {
    zip: '35223',
    category: 'Alcohol Delivery',
    storeIds: ['210'],
  },
  'go-grocer': {
    zip: '60613',
    category: 'Grocery Delivery',
    storeIds: ['222'],
  },
  'nortons-florist': {
    zip: '35233',
    category: 'Flower Delivery',
    storeIds: ['228'],
  },
  carters: {
    zip: '92173',
    category: 'Baby Products Delivery',
    storeIds: ['241'],
  },
  petsmart: {
    zip: '35203',
    category: 'Pet Supplies Delivery',
    storeIds: ['251'],
  },
  'ada-fresh-market': {
    zip: '49301',
    category: 'Grocery Delivery',
    storeIds: ['260'],
  },
  'forest-hills-foods': {
    zip: '49546',
    category: 'Grocery Delivery',
    storeIds: ['261'],
  },
  'dillonvale-iga': {
    zip: '45236',
    category: 'Grocery Delivery',
    storeIds: ['262'],
  },
  'martins-super-markets': {
    zip: '46530',
    category: 'Grocery Delivery',
    storeIds: ['263'],
  },
  'supermercado-nuestra-familia': {
    zip: '68108',
    category: 'Grocery Delivery',
    storeIds: ['265'],
  },
  'lafayette-foods': {
    zip: '48207',
    category: 'Grocery Delivery',
    storeIds: ['266'],
  },
  'giant-food': {
    zip: '19967',
    category: 'Grocery Delivery',
    storeIds: ['269'],
  },
  'giant-co': {
    zip: '18201',
    category: 'Grocery Delivery',
    storeIds: ['270'],
  },
  'stop-shop': {
    zip: '08865',
    category: 'Grocery Delivery',
    storeIds: ['271'],
  },
  'family-fresh-market': {
    zip: '68847',
    category: 'Grocery Delivery',
    storeIds: ['404'],
  },
  'zerbos-market': {
    zip: '48390',
    category: 'Grocery Delivery',
    storeIds: ['412'],
  },
  'tonys-fresh-market': {
    zip: '60070',
    category: 'Grocery Delivery',
    storeIds: ['413'],
  },
  'nutrition-smart': {
    zip: '33026',
    category: 'Health Food Delivery',
    storeIds: ['419'],
  },
  'ulta-beauty-at-target': {
    zip: '10601',
    category: 'Beauty Products Delivery',
    storeIds: ['449'],
  },
  'cleveland-fairfax-market': {
    zip: '44106',
    category: 'Grocery Delivery',
    storeIds: ['452'],
  },
  'marrow-detroit-provisions': {
    zip: '48214',
    category: 'Grocery Delivery',
    storeIds: ['454'],
  },
  specs: {
    zip: '77006',
    category: 'Alcohol Delivery',
    storeIds: ['456'],
  },
  cub: {
    zip: '55369',
    category: 'Grocery Delivery',
    storeIds: ['457'],
  },
  lowes: {
    zip: '03110',
    category: 'Home Improvement Delivery',
    storeIds: ['460'],
  },
  'save-mart': {
    zip: '93611',
    category: 'Grocery Delivery',
    storeIds: ['180', '466'],
  },
  'lucky-california': {
    zip: '94558',
    category: 'Grocery Delivery',
    storeIds: ['467'],
  },
  foodmaxx: {
    zip: '95608',
    category: 'Grocery Delivery',
    storeIds: ['468'],
  },
  'jayc-food-store': {
    zip: '47119',
    category: 'Grocery Delivery',
    storeIds: ['483'],
  },
  'pick-n-save': {
    zip: '53051',
    category: 'Grocery Delivery',
    storeIds: ['484'],
  },
  'pay-less-super-markets': {
    zip: '47906',
    category: 'Grocery Delivery',
    storeIds: ['485'],
  },
  'tom-thumb': {
    zip: '75206',
    category: 'Grocery Delivery',
    storeIds: ['812'],
  },
  'price-chopper': {
    zip: '66213',
    category: 'Grocery Delivery',
    storeIds: ['489'],
  },
  schnucks: {
    zip: '63117',
    category: 'Grocery Delivery',
    storeIds: ['491'],
  },
  vons: {
    zip: '89113',
    category: 'Grocery Delivery',
    storeIds: ['814'],
  },
  pavilions: {
    zip: '91030',
    category: 'Grocery Delivery',
    storeIds: ['813'],
  },
  'jewel-osco': {
    zip: '60202',
    category: 'Grocery Delivery',
    storeIds: ['497'],
  },
  'acme-markets': {
    zip: '18940',
    category: 'Grocery Delivery',
    storeIds: ['499'],
  },
  'strack-van-til': {
    zip: '46322',
    category: 'Grocery Delivery',
    storeIds: ['702'],
  },
  'kings-food-markets': {
    zip: '07432',
    category: 'Grocery Delivery',
    storeIds: ['817'],
  },
  balduccis: {
    zip: '20814',
    category: 'Grocery Delivery',
    storeIds: ['818'],
  },
  albertsons: {
    zip: '92648',
    category: 'Grocery Delivery',
    storeIds: ['708'],
  },
  'food-4-less': {
    zip: '90605',
    category: 'Grocery Delivery',
    storeIds: ['742'],
  },
  'metro-market': {
    zip: '53066',
    category: 'Grocery Delivery',
    storeIds: ['743'],
  },
  'ruler-foods': {
    zip: '47630',
    category: 'Grocery Delivery',
    storeIds: ['744'],
  },
  'the-fresh-market': {
    zip: '28803',
    category: 'Grocery Delivery',
    storeIds: ['802'],
  },
  'total-wine-more': {
    zip: '33180',
    category: 'Alcohol Delivery',
    storeIds: [
      '731',
      '725',
      '741',
      '715',
      '739',
      '738',
      '716',
      '737',
      '736',
      '735',
      '734',
      '717',
      '718',
      '801',
      '733',
      '803',
      '804',
      '732',
      '719',
      '826',
      '720',
      '721',
      '730',
      '722',
      '723',
      '729',
      '724',
      '740',
      '728',
      '727',
      '726',
    ],
  },
  'independence-market': {
    zip: '48346',
    category: 'Grocery Delivery',
    storeIds: ['805'],
  },
}
